module.exports = __webpack_public_path__ + "img/mining_small.69aae947.png";